import { TileLayer } from "react-leaflet";
import { VolcanosMarker } from "Components/Molecules/M_VViewer/VolcanosMarker";
import { Viewer } from "Components/Templates/T_Viewer/Viewer";
import { useMarkerState } from "hooks/useMarkerState";
import { SelectedVolcano } from "Components/Molecules/M_VViewer/SelectedVolcano";
import { useSelector } from "react-redux";

export const VolcanosMap = (
	{ volcanoItems, volcanoSelected, selectVolcano, network_filters }
) => {

   const mapLayer = useSelector(state => state.appliedMapLayer);

	const {
		positionRef, handleSelectedMarker
	} = useMarkerState( selectVolcano, [ 3.5, -73.9 ]);

	const handleOnClick = () => volcanoSelected !== null
		&& selectVolcano( null );

	const findIndex = event => volcanoItems.findIndex(
		({ id }) => id === event.id
	);

	const handleDevices = ({ geometry }) => ({
		validate: true,
		place: [ geometry.coordinates[0], geometry.coordinates[1] ]
	});

	return (
		<Viewer
			id = "leafletMapIdVolcano"
			initPosition = { positionRef.current }
			initialZoom = { 7 }
			mapOptions = {{ maxZoom: 13, minZoom: 5 }}
			onClick = { handleOnClick }
			selectEvent = { selectVolcano }
			Tiles = { 
            <TileLayer 
               url = { mapLayer } 
            /> 
         }
			netWorksMarkers = { network_filters }
			BuildMarkers = {
				<>
					{
						volcanoSelected && (
							<SelectedVolcano
								event = { volcanoSelected }
								onSelect = { selectVolcano }
							/>
						)
					}
					{
						volcanoItems.map( event => (
							<VolcanosMarker
								key = { `volcanoMarker-${ event.id }` }
								volcano = { event }
								onSelect = {
									() => handleSelectedMarker(
										event, findIndex, handleDevices
									)
								}
								moreRecent = { volcanoItems[0] && event.id === volcanoItems[0].id }
							/>
						))
					}
				</>
			}
			onMoveEnd = { () => '' }
		/>
	);
}